import { render, staticRenderFns } from "./regionResult.vue?vue&type=template&id=661f53d1&scoped=true&"
import script from "./regionResult.vue?vue&type=script&lang=js&"
export * from "./regionResult.vue?vue&type=script&lang=js&"
import style0 from "./regionResult.vue?vue&type=style&index=0&id=661f53d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f53d1",
  null
  
)

export default component.exports